function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.124 1.227c1.45 0 2.623 1.185 2.623 2.644 0 .097 0 .18-.01.267l-.032.243.085.02c.698.212 1.195.867 1.195 1.63 0 .887-.667 1.617-1.523 1.712H1.714C.77 7.742 0 6.982 0 6.03c0-.942.772-1.715 1.713-1.715l.15.01.05-.115c.298-.54.87-.91 1.535-.91l.106.01.063-.22c.328-1.08 1.322-1.863 2.507-1.863z",
  fill: "#a6a6a6",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.124 1.777c1.153 0 2.094.93 2.094 2.084 0 .17-.02.33-.052.478l-.127.35.114.178.127-.01c.646 0 1.175.518 1.175 1.163 0 .602-.465 1.1-1.047 1.163H1.713c-.646 0-1.175-.518-1.175-1.164 0-.646.528-1.164 1.173-1.164.076 0 .16.01.234.02l.106.033.222-.118.148-.38c.212-.338.592-.57 1.016-.57.084 0 .17.01.243.02l.18.064.18-.137.042-.34c.19-.95 1.036-1.67 2.04-1.67z",
  fill: "#434343",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.525 4.038l-.486.408 1.518.41-.145-1.588-.51.428c-1.136-.875-2.495-.19-2.824.832-.1.428.402.45.467.147.18-.593 1.1-1.255 1.978-.638zM5.03 6.108l.48-.402-1.53-.442.165 1.614.51-.43c1.147.89 2.49.217 2.813-.812.08-.413-.413-.44-.484-.147-.158.6-1.078 1.25-1.953.617z",
  fill: "#d9d9d9",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.423.508C.423.233.656 0 .93 0h8.135c.275 0 .497.233.497.508v2c0 .274-.222.496-.497.496H.93c-.274 0-.507-.222-.507-.497z",
  fill: "#f90",
  fillRule: "evenodd"
});

var SvgLicenseTrial = function SvgLicenseTrial(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "9.9847851mm",
    height: "7.7424402mm",
    viewBox: "0 0 9.9847852 7.7424402",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, React.createElement("path", {
    d: "M2.478.925h-.422V2.31q0 .12-.053.178-.053.057-.138.057-.086 0-.14-.06-.054-.057-.054-.175V.925h-.42q-.1 0-.146-.043-.048-.045-.048-.116 0-.074.05-.117.05-.045.145-.045h1.23q.1 0 .147.044.05.043.05.115 0 .07-.05.116-.05.044-.148.044zm.945.772h-.135v.613q0 .12-.053.178-.054.057-.14.057-.092 0-.143-.06-.05-.06-.05-.175V.843q0-.125.056-.18.055-.057.18-.057h.628q.13 0 .223.012.09.01.164.044.09.038.16.108.068.07.103.164.036.092.036.196 0 .213-.12.34-.12.128-.365.182.102.054.196.16.093.107.166.228.074.12.115.218.04.096.04.132 0 .038-.023.076-.024.036-.065.057-.043.022-.098.022-.066 0-.11-.03t-.077-.078L4.03 2.3l-.154-.258q-.083-.142-.15-.216-.065-.074-.132-.102-.068-.027-.17-.027zm.22-.8H3.29v.523h.346q.14 0 .234-.023.095-.025.144-.082.05-.06.05-.16 0-.08-.04-.14-.04-.06-.11-.09t-.268-.03zm1.19 1.413V.807q0-.117.055-.175.053-.06.137-.06.088 0 .14.06.055.057.055.175V2.31q0 .118-.054.176-.053.06-.14.06-.084 0-.138-.06-.054-.06-.054-.176zm2.037-.013l-.09-.24h-.775l-.09.245q-.055.143-.092.194-.038.05-.124.05-.075 0-.13-.054-.057-.054-.057-.12 0-.04.013-.082t.043-.116L6.057.936l.05-.127q.03-.078.062-.127.034-.05.087-.08.055-.03.134-.03.083 0 .136.03.055.03.087.08.034.047.056.103l.057.147.5 1.23q.057.14.057.204 0 .066-.056.122-.054.054-.132.054-.046 0-.078-.017-.033-.016-.055-.043-.022-.028-.048-.086l-.043-.103zm-.764-.53h.57L6.388.98l-.282.787zm1.838-.96v1.388h.783q.093 0 .143.046.05.047.05.116 0 .07-.05.115-.048.043-.143.043h-.933q-.126 0-.182-.055-.054-.056-.054-.18V.806q0-.117.052-.175.053-.06.14-.06.086 0 .14.06.054.058.054.176z",
    style: {
      lineHeight: "125%",
      textAlign: "start"
    },
    fontWeight: 400,
    fontSize: "2.66347218px",
    fontFamily: "Arial Rounded MT Bold",
    letterSpacing: "0px",
    wordSpacing: "0px",
    fill: "#fff"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLicenseTrial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/License-Trial.c04e1f1a.svg";
export { ForwardRef as ReactComponent };